__webpack_require__.p = "https://whatineedreact.blob.core.windows.net/react-build-stg/";